import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SUFFIX = "ViaMenu — Seu Cardápio Digital";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Início",
  "/login": "Login",
  "/cadastro": "Cadastro",
  "/dashboard": "Dashboard",
  "/planos": "Planos",
  "/funcionalidades": "Funcionalidades",
  "/integracoes": "Integrações",
  "/contato": "Contato",
  "/ajuda": "Central de Ajuda",
  "/documentacao": "Documentação",
  "/status": "Status",
  "/termos": "Termos de Uso",
  "/privacidade": "Política de Privacidade",
  "/tutoriais": "Tutoriais",
  "/changelog": "Changelog",
  "/api": "API",
  "/gerenciar-cardapio": "Gerenciar Cardápio",
  "/cozinha": "Painel da Cozinha",
  "/pedidos": "Pedidos",
  "/clientes": "Clientes",
  "/estoque": "Estoque",
  "/relatorio-custos": "Relatório de Custos",
  "/relatorios": "Relatórios",
  "/fidelidade": "Fidelidade",
  "/minha-conta": "Minha Conta",
  "/delivery": "Delivery",
  "/mesas": "Mesas Ativas",
  "/pdv": "PDV",
  "/ifood": "Integração iFood",
  "/instagram-shop": "Instagram Shop",
  "/whatsapp-catalogo": "Catálogo WhatsApp",
  "/marketing": "Marketing",
  "/crescimento": "Crescimento",
  "/financeiro": "Financeiro",
  "/funcionarios": "Funcionários",
  "/chat-clientes": "Chat com Clientes",
  "/garcom/login": "Login Garçom",
  "/garcom": "PDV Garçom",
  "/admin/login": "Admin Login",
  "/admin": "Painel Admin",
  "/install": "Instalar App",
  "/lp": "ViaMenu",
  "/configuracoes": "Configurações",
  "/configuracoes/aparencia": "Aparência",
  "/configuracoes/endereco": "Endereço",
  "/configuracoes/horario": "Horário",
  "/configuracoes/redes-sociais": "Redes Sociais",
  "/configuracoes/analytics": "Analytics",
  "/configuracoes/delivery": "Delivery",
  "/configuracoes/pagamento": "Pagamento",
  "/configuracoes/qr-codes": "QR Codes",
  "/configuracoes/popups": "Popups e Promoções",
  "/configuracoes/faturamento": "Faturamento",
  "/configuracoes/whatsapp": "WhatsApp",
  "/afiliado/login": "Login Afiliado",
  "/afiliado/cadastro": "Cadastro Afiliado",
  "/afiliado": "Painel do Afiliado",
};

/**
 * Sets document.title based on the current route.
 * Skips routes handled by individual pages (e.g. MenuDigital sets its own title).
 */
export function useRouteTitles() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Skip menu digital routes — they set their own title with restaurant name
    if (path.match(/^\/[^/]+$/) && !ROUTE_TITLES[path]) return;
    if (path === "/menu") return;

    const title = ROUTE_TITLES[path];
    if (title) {
      document.title = `${title} - ${SUFFIX}`;
    }
  }, [location.pathname]);
}
